module.exports = __webpack_public_path__ + "img/XBN-GRADIANT-PNG.855c9a1f.png";